import "./exam_session.js";
import "./exam_session_toggle_submit_button.js";
import "./browser_console.js";

document.addEventListener("efp-timer-done", (event) => {
  window.exam_session_answer_form?.requestSubmit();
});

document.addEventListener("click", (e) => {
  if (e.target.matches("input")) return;

  const target = e.target.closest(".js-question-option");
  if (!target) return;

  const input = target.querySelector("input");

  if (input.type === "radio") {
    input.checked = true;
  } else {
    input.checked = !input.checked;
  }

  input.dispatchEvent(new Event("change", { bubbles: true }));
});

// document.addEventListener("turbo:load", () => {
//   document.querySelector('.js-question-option input')?.focus();
// })
